import ServiceFactory from "utilities/services/service-factory";
import ServiceHookFactory from "utilities/services/service-hook-factory";
import GroupMigrationRequestRecord from "models/view-models/group-migration-request-record";

// ---------------------------------------------------------------------------------------------
// #region Interfaces
// ---------------------------------------------------------------------------------------------

export interface GroupBasePathParams {}

export interface GroupResourcePathParams extends GroupBasePathParams {
    sourceGroupId: number;
}

// #endregion Interfaces

// ---------------------------------------------------------------------------------------------
// #region Constants
// ---------------------------------------------------------------------------------------------

const baseEndpoint = "groups";
const resourceType = GroupMigrationRequestRecord;
const resourceEndpoint = `${baseEndpoint}/:sourceGroupId`;
const migrateEndpoint = `${resourceEndpoint}/migrate`;
const key = "groups";

// #endregion Constants

// ---------------------------------------------------------------------------------------------
// #region Service
// ---------------------------------------------------------------------------------------------

const GroupMigrateService = {
    key,

    /**
     * migrate a Group's owner and members to another group
     */
    migrate: ServiceFactory.update<
        GroupMigrationRequestRecord,
        GroupBasePathParams
    >(resourceType, migrateEndpoint),

    /**
     * Custom hook for leveraging service update calls in react components
     */
    useMigrate: ServiceHookFactory.useUpdate<
        GroupMigrationRequestRecord,
        GroupResourcePathParams
    >(resourceType, migrateEndpoint),
};

// #endregion Service

// ---------------------------------------------------------------------------------------------
// #region Exports
// ---------------------------------------------------------------------------------------------

export default GroupMigrateService;

// #region Exports
